export const MODULE_NAME = 'DASHBOARD_MODULE';
